import React from 'react';

import { AutomationContactRecipients } from './Contacts';
import { AutomationTagRecipients } from './Tags';

function AutomationRecipients({ automation }) {
  return automation?.contacts?.tags?.length > 0 ? (
    <AutomationTagRecipients automation={automation} />
  ) : (
    <AutomationContactRecipients automation={automation} />
  );
}

export { AutomationRecipients };
